export default __webpack_public_path__ + "static/media/dongzhi-angbao-bonus.818954f0.webp";